import { LocalizationState } from "../../contexts/Localization/LocalizationProvider"

export const english: LocalizationState = {
    locale: 'en-us',
    translations: {
        DatatableView: 'Datatable View',
    },
    timezone: 'PST',
} as any